import React from "react";
import ModalShell from "./ModalShell";

const SaveSearchModal = ({ name, onNameChange, filterCount, onClose, onConfirm }) => (
  <ModalShell title="Save current search" maxWidth={480} onClose={onClose}>
    <div className="jv2-modal-body">
      <label className="save-search-field-label">Advanced search name</label>
      <input
        type="text"
        className="save-search-name-input"
        placeholder="e.g. Shortlisted in Mumbai"
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") onConfirm(); }}
      />
      {filterCount > 0 && (
        <p style={{ textAlign: "left", fontSize: 12, color: "#8a9199", marginTop: 6, marginBottom: 0 }}>
          {filterCount} filter{filterCount > 1 ? "s" : ""} will be saved.
        </p>
      )}
    </div>
    <div className="jv2-modal-footer">
      <button className="jv2-modal-cancel" onClick={onClose}>Cancel</button>
      <button className="jv2-modal-confirm" onClick={onConfirm}>Save</button>
    </div>
  </ModalShell>
);

export default SaveSearchModal;
